import React from 'react';
import FearGreedGauge from '../../components/ui/FearGreedGauge';
import WorkspaceTabs from '../../components/ui/WorkspaceTabs';
import { CRYPTO_TABS } from './cryptoTabs';

/**
 * Crypto workspace — Fear & Greed sub-page.
 * Renders only the CoinMarketCap Fear & Greed gauge (data + methodology).
 */
export default function CryptoFearGreedPage() {
  return (
    <div style={s.page}>
      <h1 style={s.title}>Crypto Fear &amp; Greed</h1>
      <p style={s.subtitle}>
        Market sentiment for cryptocurrencies from CoinMarketCap — a 0 to 100
        score combining price momentum, volatility, volume, social signals,
        Bitcoin dominance and Google Trends.
      </p>

      <WorkspaceTabs tabs={CRYPTO_TABS} />

      <FearGreedGauge
        endpoint="/api/sentiment/fear-greed/crypto"
        title="Crypto Fear &amp; Greed Index"
      />
    </div>
  );
}

const s = {
  page: { padding: '0 0 48px' },
  title: { margin: 0, fontSize: '26px', fontWeight: 800, color: 'var(--text-primary)' },
  subtitle: { margin: '4px 0 20px', fontSize: '14px', color: 'var(--text-secondary)', maxWidth: '720px' },
};
